import { LitElement } from 'lit';
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from '@lingui/core';
import { messages as nbMessages} from '../src/raw/circle-user-filled/locales/nb/messages.mjs';
import { messages as enMessages} from '../src/raw/circle-user-filled/locales/en/messages.mjs';
import { messages as fiMessages} from '../src/raw/circle-user-filled/locales/fi/messages.mjs';
import { activateI18n } from '../src/utils/i18n';
activateI18n(enMessages, nbMessages, fiMessages);


export class IconCircleUserFilled24 extends LitElement {
  render() {
      const title = i18n.t({ message: `Person in a circle`, id: 'icon.title.circle-user-filled', comment: 'Title for circle user filled icon' });
      
      return html`<svg xmlns="http://www.w3.org/2000/svg"width="24"height="24"fill="none"viewBox="0 0 24 24" part="w-icon-circle-user-filled-24-part">${unsafeStatic(`<title>${title}</title>`)}<path fill="currentColor" fill-rule="evenodd" d="M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12m12 10.5c-2.375 0-4.565-.788-6.324-2.117a9.1 9.1 0 0 1 2.833-1.914 8.9 8.9 0 0 1 7.003 0 9.1 9.1 0 0 1 2.824 1.904A10.45 10.45 0 0 1 12 22.5M12 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12M7.906 8.13a4.5 4.5 0 1 0 8.582 1.54 10.7 10.7 0 0 1-2.645.33 10.6 10.6 0 0 1-3.417-.56 9.3 9.3 0 0 1-2.52-1.31" clip-rule="evenodd"></path></svg>`; }
}
if (!customElements.get('w-icon-circle-user-filled-24')) {
  customElements.define('w-icon-circle-user-filled-24', IconCircleUserFilled24);
}